import { TokenStorageService } from '../tokenStorage.js';
import toastr from 'toastr';
const tokenStorageService = new TokenStorageService();

$(function() {
    $('.favorite_button').on('click', function (event) {
        const holder = $(this);
        const button = holder.find('button.love_anime').first()
        const mangaId = holder.data('id');

        // Disable button to prevent duplicate requests
        button.prop('disabled', true);

        if (tokenStorageService.isLoggedIn()) {
            // Make a POST request to the remote API
            axios.post(`https://api.abyssreader.com/api/users/favorite/${mangaId}`)
            .then(response => {
                const isFavorite = response.data; // Assuming response is a boolean

                // Toggle the favorite state
                if (isFavorite) {
                    button.addClass('on');
                    button.find('i').removeClass('far').addClass('fas');
                    toastr.success("The manga has been added to your favorites");
                } else {
                    button.removeClass('on');
                    button.find('i').removeClass('fas').addClass('far');
                    toastr.success("The manga has been removed from favorites");
                }
            })
            .catch(error => {
                toastr.error("An error occurred during the process, please try again!");
            })
            .finally(() => {
                // Re-enable the button
                button.prop('disabled', false);
            });
        } else {
            // Show login prompt if not logged in
            tokenStorageService.showPoPupLogin();
            // Re-enable the button
            button.prop('disabled', false);
        }
    });
});
